module.exports = __webpack_public_path__ + "static/media/lettuce-wrap.94e0f8d4.png";